import ItemViewArgs from './ItemViewArgs';
import Modal from './Modal';
import AbstractItemView from './item/AbstractItemView';

class FolderView extends AbstractItemView {
  constructor(args: ItemViewArgs<Modal>) {
    super(args);
  }

  protected getItemPrefix(): string {
    return 'folder';
  }
}

export default FolderView;
